import * as React from "react";
import { get } from "lodash";
import { findFieldValue } from "web_modules/underwriter_dashboard/shared";

import Money from "web_modules/Money";

const { Panel, Table } = require("react-bootstrap");

interface IWVOEPanelProps {
  docs: any;
  header: string;
  setDocId: Function;
  renderCurrent?: Boolean;
  employment?: any;
}

class WVOEPanel extends React.Component<IWVOEPanelProps, any> {
  getMonthlyAverage() {
    const { employment } = this.props;
    // @TODO replace with something more substantial. We threw in the lodash `get` to prevent a page crash
    const wvoeBasePaySources = get(
      employment,
      "income_aggregations[0].context.base_pay_sources",
      [],
    ).filter(b => b.source === "WVoE");
    if (wvoeBasePaySources.length > 0) {
      return wvoeBasePaySources[0].monthly_average;
    }
    return 0;
  }

  renderWVOE(doc) {
    return (
      <div>
        <Table className="income_documents_review_table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Employment Start Date</th>
              <th>Employment End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <a onClick={this.props.setDocId.bind(this, doc.id)}>WVOE [ID: {doc.id}]</a>
              </td>
              <td>{findFieldValue(doc, "applicant_date_of_employment")}</td>
              <td>
                {findFieldValue(doc, "date_terminated") ||
                  `Current - ${findFieldValue(
                    doc,
                    "applicant_probability_of_continued_employment",
                  )}`}
              </td>
            </tr>
          </tbody>
        </Table>
        <Table className="income_documents_review_table">
          <thead>
            <tr>
              <th>Avg Hours Per Week</th>
              <th>Base Pay Rate</th>
              <th>Monthly Average</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{findFieldValue(doc, "average_hours_per_week")}</td>
              <td>
                <Money value={findFieldValue(doc, "applicant_current_gross_pay")} /> /{" "}
                {findFieldValue(doc, "applicant_pay_period")}
              </td>
              <td>
                <Money value={this.getMonthlyAverage()} />
              </td>
            </tr>
          </tbody>
        </Table>
        <Table className="income_documents_review_table">
          <thead>
            <tr>
              <th>Pay Type</th>
              <th>YTD</th>
              <th>Prior Year</th>
              <th>Two Years Prior</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Base</td>
              <td>
                <Money value={findFieldValue(doc, "ytd_base_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_base_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_base_pay")} />
              </td>
            </tr>
            <tr>
              <td>Overtime</td>
              <td>
                <Money value={findFieldValue(doc, "ytd_overtime_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_overtime_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_overtime_pay")} />
              </td>
            </tr>
            <tr>
              <td>Bonus</td>
              <td>
                <Money value={findFieldValue(doc, "ytd_bonus_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_bonus_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_bonus_pay")} />
              </td>
            </tr>
            <tr>
              <td>Commission</td>
              <td>
                <Money value={findFieldValue(doc, "ytd_commission_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_commission_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_commission_pay")} />
              </td>
            </tr>
            <tr>
              <td>
                Other{" "}
                {findFieldValue(doc, "other_pay_type") !== ""
                  ? `- ${findFieldValue(doc, "other_pay_type")}`
                  : ""}
              </td>
              <td>
                <Money value={findFieldValue(doc, "ytd_other_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_other_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_other_pay")} />
              </td>
            </tr>
            <tr className="income_documents_review__total_row">
              <td>TOTALS</td>
              <td>
                <Money value={findFieldValue(doc, "ytd_total_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "past_year_total_pay")} />
              </td>
              <td>
                <Money value={findFieldValue(doc, "two_years_ago_total_pay")} />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>{this.props.header}</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {this.props.docs.map((wvoe, i) => <div key={i}>{this.renderWVOE(wvoe)}</div>)}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default WVOEPanel;
